import "../layouts/default"
import './account-jquery'

import '../ui/slider'
import '../ui/more-items'
import '../ui/horizontal-scroll'

import '../common/price-offer-detail'
import '../common/price-offer-clients'

import { initTippyDropdown } from "Functions/tippy";
import Swiper, { Navigation } from 'swiper';
import { initDatepickers, initDatepickerRanges } from '../functions/datepicker'

Swiper.use([Navigation]);
initDatepickers();
initDatepickerRanges();
initTippyDropdown();

const lang = document.querySelector('html').getAttribute('lang')
let localeSwal

import(`../locale/${lang}`).then((module) => {
    localeSwal = module.Swal
})

document.addEventListener('click', (event) => {
    const trigger = event.target.closest('.js-price-offer-delete')

    if (!trigger || !localeSwal) {
        return
    }

    const url = trigger.getAttribute('href')

    event.preventDefault()

    // the third argument runs as swal preConfirm and is called unconditionally, it must be a function
    Eshop.confirm(
        localeSwal.DeletePriceOffer.title,
        {
            denyButtonText: localeSwal.DeletePriceOffer.deny,
            confirmButtonText: localeSwal.DeletePriceOffer.confirm
        },
        () => {
            window.location.href = url
        }
    )
})

// The offers listing (pager, load more) and its filter (from/to/status/customer) are handled
// by the standard Listing + Filter subsystem - no custom handlers needed here anymore.

// Mirror the selected status colour dot on the filter (the form is not re-rendered on the
// AJAX filter submit, so the modifier class has to be kept in sync client side).
const priceOfferStatusFilter = document.querySelector('#price-offer-filter-status');

if (priceOfferStatusFilter) {
    const statusWrapper = priceOfferStatusFilter.closest('.c-price-offer-status-filter');
    const statusModifiers = { '1': 'pending', '2': 'approved', '3': 'rejected' };

    const syncStatusDot = () => {
        if (!statusWrapper) {
            return;
        }

        Object.values(statusModifiers).forEach((modifier) => {
            statusWrapper.classList.remove('c-price-offer-status-filter--' + modifier);
        });

        const modifier = statusModifiers[priceOfferStatusFilter.value];

        if (modifier) {
            statusWrapper.classList.add('c-price-offer-status-filter--' + modifier);
        }
    };

    priceOfferStatusFilter.addEventListener('change', syncStatusDot);
}

function toggleRegisterWarning(show) {
    const warning = document.getElementById('b2b-register-warning');

    if (warning) {
        warning.classList.toggle('is-hidden', !show);
    }
}

rEvent.on("Finstat.select.after", function (elem, data) {
    toggleRegisterWarning(data.result.length < 1 ? true : false);
});
rEvent.on("Finstat.orgNum.after", function (elem, data) {
    toggleRegisterWarning(data.result.length < 1 ? true : false);
});

rEvent.on("Finstat.select.error", function (elem, data) {
    toggleRegisterWarning(true);
});
rEvent.on("Finstat.source.error", function (elem, data) {
    toggleRegisterWarning(true);
});
rEvent.on("Finstat.orgNum.error", function (elem, data) {
    toggleRegisterWarning(true);
});

rEvent.on("Listing.fetchedData", function (data) {
    requestAnimationFrame(() => {
        if ($(".listing__holder").length) {
            $(".listing__holder").removeClass("is-loading");
        }

        if ($(".pager__load").length) {
            $(".pager__load").removeClass("is-loading");
        }
    });

    initTippyDropdown();
});

const accountFilterSearch = document.querySelector(".js-account-filter-search");

if (accountFilterSearch) {
    accountFilterSearch.addEventListener("keyup", () => {
        Filter.submit();
    });
}

const fakeSearch = document.querySelector(".js-fake-search");
if (fakeSearch && accountFilterSearch) {
    fakeSearch.addEventListener("keyup", () => {
        accountFilterSearch.value = fakeSearch.value;
        Filter.submit();
    });
}
